import { AddressModel } from "../../address.model";

export class CreditCardPaymentInfoModel {
    creditCardNumber: string = "";
    creditCardNumberLast: string = "";
    cardHolderName: string = "";
    expiryMonth?: number;
    expiryYear?: number;
    cvvNumber?: string;
    billingAddress: AddressModel = new AddressModel();

    expiryDate: string = "";
}